import { Product, ProductShortName, SubscriptionType } from '@app/enums/_index';

import { Factory } from './_factory';
import { Injectable } from '@angular/core';
import { LearningPlanTilesItem } from '@app/models/_index';
import { environment } from '@environments/environment';

/**
 * Create Learning Plan Tile Item Factory used by the Voucher Redemption component.
 * Creates instances of Filter Learning Plan Tile Item
 */
@Injectable({
  providedIn: 'root',
})
export class LearningPlanTilesFactory implements Factory<LearningPlanTilesItem> {
  learningPlanTileInfo: LearningPlanTilesItem[] = [];

  /**
   * Call and build static Filter Learning Plan Tile Item array.
   * Do not add or remove items from this array.
   * Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static Filter Learning Plan Tile Item array
   */
  build(): void {
    this.learningPlanTileInfo.push(
      new LearningPlanTilesItem(
        'AI Essentials Basics',
        'The courses aim to equip learners with a foundational understanding of AI principles and techniques.',
        `${environment.docebo.url}/learn/lp/617/ai-essentials-basics`,
        'ai-essentials-basics'
      )
    );
    this.learningPlanTileInfo.push(
      new LearningPlanTilesItem(
        'AI Essentials Knowledge Workbench and Bots',
        'The courses equip you with the necessary skills to design, develop, and deploy AI-powered bots.',
        `${environment.docebo.url}/learn/lp/618/ai-essentials-knowledge-workbench-and-bots`,
        'ai-essentials-knowledge-workbench-and-bots'
      )
    );
    this.learningPlanTileInfo.push(
      new LearningPlanTilesItem(
        'AI Essentials Predictive Engagement and Predictive Routing',
        'The courses cover predictive routing techniques that utilize AI to dynamically match incoming requests or inquiries.',
        `${environment.docebo.url}/learn/lp/619/ai-essentials-predictive-engagement-and-predictive-routing`,
        'ai-essentials-predictive-engagement-and-predictive-routing'
      )
    );
  }

  /**
   * Return immutable or copy of Filter Learning Plan Tile Item collection
   * @returns - a slice or copy of these static collection
   */
  getCollection(): LearningPlanTilesItem[] {
    return this.learningPlanTileInfo.slice();
  }
}
